<script>
  import { fly, blur } from 'svelte/transition';
  import TitleNNumber from '../ComponentsInProcess/TitleNNumber.svelte';
  export let idFiche;
</script>

{#if !idFiche}
  <div in:fly="{{ x: 50, duration: 500 }}">
    <TitleNNumber idFiche="0" />
  </div>
{:else if idFiche == 1}
  <div in:fly="{{ x: 50, duration: 500 }}">
    <TitleNNumber idFiche="{idFiche}" titre="{'Quel type d’installation ?'}" />
  </div>
{:else if idFiche == 2}
  <div in:fly="{{ x: 50, duration: 500 }}">
    <TitleNNumber
      idFiche="{idFiche}"
      titre="{'Longueur et largeur de votre trappe'}"
    />
  </div>
{:else if idFiche == 3}
  <div in:fly="{{ x: 50, duration: 500 }}">
    <TitleNNumber idFiche="{idFiche}" titre="{'Côté d’ouverture'}" />
  </div>
{:else if idFiche == 4}
  <TitleNNumber idFiche="{idFiche}" titre="{'Type de fermeture'}" />
{:else if idFiche == 5}
  <TitleNNumber idFiche="{idFiche}" titre="{'Couleur'}" />
{/if}
